export default __webpack_public_path__ + "static/media/img14.0200eea6.png";